export const ERROR_INDENTITY_SAVE =
   'Unable to create User for this contact. Please try again by updating the contact details.';
export const SUCCESS_SAVE = 'Contact details saved.';
export const ERROR_REGISTRATION_EXIST = 'Licence Number already exist';
export const ERROR_POBOX = `Physical Address cannot be a 'PO BOX' address`;
export const ERROR_VALIDATION_FAIL =
   'Validation Failed: Please enter all required fields';
